import Resource from './Resource'
import { EntityComparatorUtils } from '@/shared/util/entity-comparator-utils'

class PetitionerResource extends Resource {
    async paginator(params) {
        const response = await this.axios.get('/petitioners/', { params })
        response.data.content.sort(EntityComparatorUtils.comparePersonsByName)
        return response.data
    }
}

export default new PetitionerResource()
